import React from 'react'
import '../../scss/variables.scss'
import '../../scss/reset.scss'
import './Button.scss'

function Button(props) {
    return (
        <button>
            {props.title}
        </button>
    )
}

export default Button
